import { IExperiments } from '../../../../../../../../../../../types/reducers/experiments';
import { servicesCardsTextsExperimentName, TExperiments } from '../../../../../../../../../../../constants/experiments';
import { IGetTexts } from './getServiceText';

export const premiumServiceControlGroup: IGetTexts = {
  title: 'Премиум',
  subtitle: 'До х3 звонков',
  description: ['Больше просмотров', 'Фото и яркий заголовок', 'Выше Стандартных'],
};

export const premiumServiceBGroup: IGetTexts = {
  title: 'Премиум',
  subtitle: 'До х3 просмотров',
  description: ['Больше показов', 'Фото и яркий заголовок', 'Выше Стандартных'],
};

export const premiumServiceCGroup: IGetTexts = {
  title: 'Премиум',
  subtitle: 'До х3 показов',
  description: ['Больше просмотров', 'Фото и яркий заголовок', 'Выше Стандартных'],
};

export const getPremiumTexts = (experiments: IExperiments, allExperiments: TExperiments): IGetTexts => {
  if (experiments[servicesCardsTextsExperimentName]) {
    const groups = allExperiments[servicesCardsTextsExperimentName];

    switch (experiments[servicesCardsTextsExperimentName]) {
      case groups?.default: {
        return premiumServiceControlGroup;
      }
      case groups?.shows: {
        return premiumServiceCGroup;
      }
      case groups?.views: {
        return premiumServiceBGroup;
      }
    }
  }

  return premiumServiceControlGroup;
};
